module.exports = __webpack_public_path__ + "static/media/9.232a3474.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/9.png
// module id = 747
// module chunks = 0